export default () => ({
  selected: null,
  startDate: null,
  endDate: null,
  dateClasses: null,
  isCurrent: null,
  isAfter: null,
  finalDate: null,

  setInitialValues(startDate, endDate, openDefault) {
    let sdSplit = startDate.split("-");
    let edSplit = endDate.split("-");
    let sDate = new Date(sdSplit[2], sdSplit[0] - 1, sdSplit[1]);
    let eDate = new Date(edSplit[2], edSplit[0] - 1, edSplit[1]);

    if (this.compareDates(startDate, endDate) == "Before date range") {
      this.dateClasses = "date-before";
    } else if (this.compareDates(startDate, endDate) == "Between date range") {
      this.dateClasses = "date-between";
      this.isCurrent = true;
    } else if (this.compareDates(startDate, endDate) == "After date range") {
      this.dateClasses = "date-after";
      this.isAfter = true;
    }

    let sd = sDate.toString().split(" ");
    let ed = eDate.toString().split(" ");

    if (this.areDatesInDifferentMonths(sDate, eDate)) {
      this.finalDate = `${sd[1]} ${sd[2]} - ${ed[1]} ${ed[2]}`;
    } else {
      this.finalDate = `${sd[1]} ${sd[2]} - ${ed[2]}`;
    }

    if (openDefault == "true") {
      this.selected = true;
    }
  },

  compareDates(startDate, endDate) {
    var today = new Date();
    var start = new Date(startDate.replace(/-/g, "/"));
    var end = new Date(endDate.replace(/-/g, "/"));

    if (today < start) {
      return "After date range";
    } else if (today >= start && today <= end) {
      return "Between date range";
    } else {
      return "Before date range";
    }
  },

  areDatesInDifferentMonths(sd, ed) {
    return (
      sd.getMonth() !== ed.getMonth() || sd.getFullYear() !== ed.getFullYear()
    );
  },
});
